import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";

interface ImageData {
    src: string;
    filename: string;
    index: number;
}

const RealisationsSection = () => {
    const [images, setImages] = useState<ImageData[]>([]);

    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    useEffect(() => {
        const importAllImages = (r: any): ImageData[] => {
            return r.keys().map((filename: string, index: number) => ({
                src: r(filename) as string,
                filename: filename.replace('./', ''),
                index,
            }));
        }

        // @ts-ignore
        try {
            // @ts-ignore
            const imageContext = require.context(
                '../img/',
                false,
                /\.(png|jpe?g|svg)$/
            );
            setImages(importAllImages(imageContext));
        } catch (err) {
            console.error(err);
        }
    }, []);

    return (
        <section id="galeria" className="section-padding bg-card">
            <div className="container mx-auto">
                <div className="text-center max-w-2xl mx-auto mb-16">
                    <span className="inline-block text-primary font-medium tracking-widest uppercase text-sm mb-4">
                        Galeria
                    </span>
                    <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                        Nasze realizacje
                    </h2>
                    <p className="text-muted-foreground text-lg">
                        Zobacz wybrane projekty, które zrealizowaliśmy dla naszych klientów.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className="group relative aspect-[4/3] bg-muted rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => setSelectedImage(image.src)}
                        >
                            <img 
                                src={image.src}
                                alt={image.filename}
                                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                            />
                        </div>
                    ))}
                </div>
            </div>

            <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
                <DialogContent className="max-w-4xl p-0 border-none bg-transparent justify-center">
                    {selectedImage && (
                        <img
                            src={selectedImage.replace('w=800', 'w=1200')}
                            alt="Powiększone zdjęcie realizacji spoko okok??"
                            className="w-full h-auto rounded-lg sm:w-auto sm:h-screen"
                        />
                    )}
                </DialogContent>
            </Dialog>
        </section>
    );
}

export default RealisationsSection;